import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { CodeConversionMstDto, SafenoticeTab, SafenoticeTargetConsumptiondevicelst } from 'sg-api';

@Component({
  selector: 'app-sgke360d-safety',
  templateUrl: './sgke360d-safety.component.html',
  styleUrl: './sgke360d-safety.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgke360dSafetyComponent implements OnInit, OnDestroy {
  /** 指針入力タブ内のレスポンス */
  @Input() safenoticeTab: SafenoticeTab = null;
  /** コード変換マスタマップ */
  @Input() codeMap: Map<string, CodeConversionMstDto[]> = null;

  /** 親フォームグループ */
  public parentForm: UntypedFormGroup;
  /** データソース */
  dataSource: MatTableDataSource<SafenoticeTargetConsumptiondevicelst>;

  /** 非安全機器・給排気設備不良機器周知チェックボックス */
  public get unsafeDeviceNoticeflag(): boolean {
    return this.getControl('unsafeDeviceNoticeflag')?.value == '1';
  }
  public set unsafeDeviceNoticeflag(v: boolean) {
    this.getControl('unsafeDeviceNoticeflag')?.setValue(v ? '1' : '0');
  }

  public get lightingExaminedFlgValue() {
    const noticeflagCtl = this.getControl('unsafeDeviceNoticeflag');
    // 非安全機器・給排気設備不良機器周知チェックボックス有効 かつ チェックオフ
    let disabled = noticeflagCtl.enabled && !this.unsafeDeviceNoticeflag;
    // 確認結果が合格
    disabled ||= this.getControl('leaktestConfirmationresultFlg').value != '1';
    const ctl = this.getControl('lightingExaminedFlg');
    if (disabled) {
      ctl.disable();
      ctl.setValue(null);
    } else {
      ctl.enable();
    }
    return ctl.value;
  }
  /** テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'setsubiNo',
    'consumptiondeviceModelname',
    'manufactureYm',
    'ventilationHoshikiMei',
    'cnnctJokyoMei',
    'saleKeitaiMei',
    'manufacturerMei',
    'model',
    'installationlocationMei',
    'nonconformityCode',
    'covalueMei',
  ];

  /**
   * コンストラクタ
   * @param {FormGroupDirective} parent
   * @param {CodeConversionMstService} codeConvert
   * @memberof Sgke360dSafetyComponent
   */
  constructor(
    private parent: FormGroupDirective,
  ) { }

  /**
   * 初期化処理
   *
   * @memberof Sgke360dSafetyComponent
   */
  ngOnInit(): void {
    // 親フォームを参照
    this.parentForm = this.parent.form.get('supplyresumptionResultInfo') as UntypedFormGroup;

    // Table表示データ作成
    this.dataSource = new MatTableDataSource<SafenoticeTargetConsumptiondevicelst>(this.safenoticeTab.safenoticeTargetConsumptiondevicelstarea);
    // コード変換マスタ取得
    let dispItemIdList = [
      'S301380',
    ];
  }
  /**
   * 終了処理
   *
   * @memberof Sgke360dSafetyComponent
   */
  ngOnDestroy(): void {
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
  }
  /**
   * フォームコントロール取得
   * @param ctlname コントロール名
   * @returns フォームコントロール
   */
  getControl(ctlname: string): FormControl {
    return this.parentForm?.get(ctlname) as FormControl;
  }
}
